// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import directive from './directive'
import filters from '@/filters/index'
import echarts from 'echarts'

// 导入i18n
import i18n from './i18n/index.js';

// google map
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAp09Yyo0IxgJRMZO4DqNs8O3ZsxgRUufY',
    libraries: 'places',
  }
});

import './permission' // permission control
import '@/components/index.js'

// import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.css'
import { message } from './utils/mesage.js';

Vue.prototype.$echarts = echarts

// import VueCropper from 'vue-cropper'
// Vue.use(VueCropper)
Vue.use(ElementUI)
Vue.prototype.$message = message;

for (let key in filters) {
  Vue.filter(key, filters[key]);
}
Vue.prototype.$filter = filters;

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js